// 将时间戳转换为日期格式
let formatDate = time => {
    let re = /-?\d+/;
    let m = re.exec(time);
    let d = new Date(parseInt(m[0]) * 1000);
    let o = {
        "M+": d.getMonth() + 1, //month
        "d+": d.getDate(), //day
        "h+": d.getHours() > 9 ? d.getHours() : '0' + d.getHours(), //hour
        "m+": d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes(), //minute
        "s+": d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds(), //second
        "q+": Math.floor((d.getMonth() + 3) / 3), //quarter
        "S": d.getMilliseconds() //millisecond
    }
    let format = "yyyy-MM-dd h:m:s";
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}
/*
params:val => 准备截取的字符串
params:num => 开始截取的下标
return:val => 返回截取后的字符串
*/
let sliceText = function(val,num){
        if(
            Object.prototype.toString.call(val) !== '[object String]' ||
            !Number.isInteger(num)||
            val.length < num
        ){
            return val
        }else{
            val = val.substr(0, num) + '.....';
        }
        return val
    }
export { formatDate, sliceText }



// WEBPACK FOOTER //
// ./src/assets/js/filters.js